// Correlation-ID stack — paralela ao mobile (`grana-money-app/src/shared/observability/correlation-id.ts`).
//
// Cada request HTTP logica empurra um ID via `push()` e remove via `pop()`
// quando termina (resposta final, sucesso ou erro). Retries reusam o mesmo
// ID via `current()`. O backend usa o header `X-Correlation-Id` para
// correlacionar logs.
//
// Stack (em vez de variavel global) porque chamadas paralelas devem ter
// IDs distintos, e o ciclo logico (push -> request -> retry? -> pop) precisa
// de LIFO local ao client.
//
// Falha de rede / timeout NAO chega ao afterResponse — o stack pode vazar
// 1 entrada por erro de rede. `clear()` em logout reseta sessao.

let stack: string[] = [];

function generate(): string {
  if (
    typeof globalThis.crypto !== 'undefined' &&
    typeof globalThis.crypto.randomUUID === 'function'
  ) {
    return globalThis.crypto.randomUUID();
  }
  return `cid-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export const correlationId = {
  push(): string {
    const id = generate();
    stack.push(id);
    return id;
  },
  current(): string | undefined {
    return stack[stack.length - 1];
  },
  pop(): void {
    stack.pop();
  },
  clear(): void {
    stack = [];
  },
};

// Test-only: inspecionar profundidade do stack para detectar leaks em testes
// que lidam com erros de rede.
export const __testOnly__ = {
  size: () => stack.length,
};
